//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'
import $ from 'jquery'
import VueAliplayer from 'vue-aliplayer'

const Pagination = require('../plugins/vue-bootstrap-paginator').default

export default {
  components: {
    ContentHeader,
    Pagination,
    'ali-player': VueAliplayer
  },
  data () {
    return {
      searchName: '',
      searchMergeStatus: '',
      searchTecentRoomId: '',
      searchOnline: '',
      searchRateType: '',
      searchMasterPvsStatus: '',
      searchSlavePvsStatus: '',
      searchDeviceName: '',
      globalInfo: {},
      totalItems: 0,
      gameRoomList: [],
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0,
      WSURL: '',
      gameWebsocket: null,
      aliplayerSource: '',
      player: null,
      focus: {},
      connectStatus: false,
      roomReady: false,
      gameReady: false,
      responseMsgs: [],
      gameRoom: {wawaji_option: {}, device: {}, device_wawaji: {}}
    }
  },
  created () {
  },
  mounted () {
    // 获取娃娃机全局属性
    let $this = this
    Vue.http.get(this.serviceUrl('api/wawaji/global/info')).then((resp) => {
      if (resp.data.globalInfo) {
        $this.globalInfo = resp.data.globalInfo
      }
    })
    $this.getGameRooms(1)
  },
  computed: {
  },
  methods: {
    // 获取产品列表
    getGameRooms: function (page = 1) {
      let params = {
        page: page,
        name: this.searchName,
        merge_status: this.searchMergeStatus,
        device_name: this.searchDeviceName,
        tencent_room_id: this.searchTecentRoomId,
        online: this.searchOnline,
        rate_type: this.searchRateType,
        master_pvs_status: this.searchMasterPvsStatus,
        slave_pvs_status: this.searchSlavePvsStatus
      }
      let $this = this
      Vue.http.get(this.serviceUrl('api/game/room/info'), {params: params}).then((resp) => {
        let data = resp.data
        $this.gameRoomList = data.gameRoomList.data;
        $this.totalItems = data.gameRoomList.total;
        $this.currentPage = data.gameRoomList.current_page;
        $this.perPage = data.gameRoomList.per_page;
        $this.lastPage = data.gameRoomList.last_page;
      });
    },
    // 分页跳转
    pageChanged: function (page = 1) {
      this.getGameRooms(page)
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getGameRooms(appointPage);
    },
    // 查看商品详情
    showGoodsDetail: function (row) {
      this.gameRoom = row;
    },
    // 视频赋值
    showVideo: function (row, type) {
      this.gameRoom = row;
      let $this = this
      $('.js-show-video-modal').modal('show');
      $('.js-show-video-modal').on('hide.bs.modal', (e) => {
        $this.aliplayerSource = ''
      })
      if (type === 1) {
        // 主直播流
        this.aliplayerSource = row.master_live_stream.live_rtmp_url;
      } else if (type === 2) {
        // 附直播流
        this.aliplayerSource = row.slave_live_stream.live_rtmp_url;
      }
    },
    // 游戏房间属性赋值
    editAttribute: function (row) {
      this.gameRoom = row;
      // if (!row.wawaji_option.rate_start_at || !row.wawaji_option.rate_end_at) {
      //     this.focus.success_rate_time = '1';
      // } else {
      //     this.focus.success_rate_time = '2';
      //     this.editDate = {startDate : row.wawaji_option.rate_start_at, endDate: row.wawaji_option.rate_end_at, startDateText: row.wawaji_option.rate_start_at, endDateText: row.wawaji_option.rate_end_at};
      // }
    },
    // 保存游戏房间属性
    saveAttribute: function () {
      let rateRe = /(?!^0\.0?0$)^[0-9][0-9]?(\.[0-9]{1,2})?$|^100$|^0.00$|^100.00$/;
      let numRe = /^\d+$/;
      // var gearRe = /^([1-9]|10|-[1-9]|-10)$/;
      let wawajiOption = this.gameRoom.wawaji_option;
      if (!rateRe.test(wawajiOption.initial_success_rate)) {
        this.alert('初始成功率不合法', 2);
        return false;
      }
      // if (!this.wawajiOption.success_rate_time) {
      //     this.alert('请选择计算实际成功率有效时间', 2);
      //     return false;
      // }
      if (!wawajiOption.rate_type) {
        this.alert('请选择概率类型', 2);
        return false;
      }
      var params = {
        gr_wawaji_id: wawajiOption.gr_wawaji_id,
        initial_success_rate: wawajiOption.initial_success_rate,
        // success_rate_time: this.wawajiOption.success_rate_time,
        rate_type: wawajiOption.rate_type
      };
      // if (this.wawajiOption.success_rate_time == '2') {
      //     if (!this.editDate.startDateText || !this.editDate.endDateText) {
      //         this.alert('请选择有效时间', 2);
      //         return false;
      //     }
      //     params['rate_start_at'] = this.editDate.startDateText;
      //     params['rate_end_at'] = this.editDate.endDateText;
      // }
      let $this = this;
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/save/game/room/wawaji'),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $('.js-edit-attribute-modal').modal('hide');
          $this.pageChanged(1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    // 游戏测试
    openWebSocket: function (row) {
      this.focus = row;
      this.connectStatus = false;
      this.roomReady = false;
      this.gameReady = false;
      this.responseMsgs = [];
    },
    // 获取Websocket地址
    getWSURL: function (row) {
      if (row === 'create') {
        this.connectWebSocket(this.WSURL);
        return;
      }
      var params = {
        game_room_id: row.game_room_id
      };
      let $this = this
      Vue.http.get(this.serviceUrl('api/websocket'), {params: params}).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.connectWebSocket($this.isHttps ? resp.data.wss_url : resp.data.ws_url);
        }
      });
    },
    // Websocket连接
    connectWebSocket: function (wsUrl) {
      let $this = this
      this.responseMsgs = [];
      let gameWebsocket = new WebSocket(wsUrl);
      gameWebsocket.onopen = function (e) {
        $this.connectStatus = true;
      };
      gameWebsocket.onclose = (e) => {
        $this.connectStatus = false;
        $this.roomReady = false;
        $this.gameReady = false;
      }
      gameWebsocket.onmessage = function (msg) {
        msg = JSON.parse(msg.data);
        $this.responseMsgs.push(msg);
        if (msg.data) {
          if (msg.data.game_session_id) {
            $this.gameReady = true;
          }
        }
        if (msg.method === 'room_ready') {
          // gameWebsocket握手成功
          $this.roomReady = true;
        } else if (msg.method === 'game_result') {
          gameWebsocket.close();
        } else if (msg.errcode) {
          gameWebsocket.close();
        }
      }
      gameWebsocket.onerror = function (event) {
        $this.alert('WebSocket连接失败', 2);
      }
      $this.gameWebsocket = gameWebsocket
    },
    // 游戏控制
    controlWebSocket: function (msg) {
      var data = {
        id: 'wowgotcha_test_player'
      };
      if (msg === 'insert_coins') {
        data['method'] = 'insert_coins';
      } else {
        data['method'] = 'control';
        data['params'] = {operation: msg};
      }
      this.gameWebsocket.send(JSON.stringify(data));
    },
    // 熊猫盒子管理
    focusOne: function (row) {
      this.gameRoom = row;
    },
    // 快速控制设备
    publishMsgFlash: function (focus, msg) {
      var data = {
        game_room_id: focus.game_room_id,
        message: msg
      };
      let $this = this
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/device/publish/msg'),
        data: data
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.alert('发送成功', 1);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    editVideo: function (row) {
      this.gameRoom = row
    },
    // 保存摄像头配置
    saveVideoParams: function (focus) {
      var numRe = /^\d+$/;
      var gearRe = /^-?\d+$/;
      if (focus.master_live_stream.resolution_width && !numRe.test(focus.master_live_stream.resolution_width)) {
        this.alert('主摄像头-分辨率宽格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.resolution_height && !numRe.test(focus.master_live_stream.resolution_height)) {
        this.alert('主摄像头-分辨率高格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.fps && !numRe.test(focus.master_live_stream.fps)) {
        this.alert('主摄像头-FPS格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.saturation && !gearRe.test(focus.master_live_stream.saturation)) {
        this.alert('主摄像头-饱和度格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.contrast && !gearRe.test(focus.master_live_stream.contrast)) {
        this.alert('主摄像头-对比度格式有误', 2);
        return false;
      }
      if (focus.master_live_stream.brightness && !gearRe.test(focus.master_live_stream.brightness)) {
        this.alert('主摄像头-亮度格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.resolution_width && !numRe.test(focus.slave_live_stream.resolution_width)) {
        this.alert('侧摄像头-分辨率宽格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.resolution_height && !numRe.test(focus.slave_live_stream.resolution_height)) {
        this.alert('侧摄像头-分辨率高格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.fps && !numRe.test(focus.slave_live_stream.fps)) {
        this.alert('侧摄像头-FPS格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.saturation && !gearRe.test(focus.slave_live_stream.saturation)) {
        this.alert('侧摄像头-饱和度格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.contrast && !gearRe.test(focus.slave_live_stream.contrast)) {
        this.alert('侧摄像头-对比度格式有误', 2);
        return false;
      }
      if (focus.slave_live_stream.brightness && !gearRe.test(focus.slave_live_stream.brightness)) {
        this.alert('侧摄像头-亮度格式有误', 2);
        return false;
      }
      var params = {
        game_room_id: focus.game_room_id,
        // 主摄像头
        master_channel_no: focus.master_live_stream.channel_no,
        master_master_no: focus.master_live_stream.master_no,
        master_cloud_service: focus.master_live_stream.cloud_service,
        master_publish_url: $.trim(focus.master_live_stream.publish_url),
        master_live_rtmp_url: $.trim(focus.master_live_stream.live_rtmp_url),
        master_live_hls_url: $.trim(focus.master_live_stream.live_hls_url),
        master_live_rtsp_url: $.trim(focus.master_live_stream.live_rtsp_url),
        master_resolution_width: focus.master_live_stream.resolution_width,
        master_resolution_height: focus.master_live_stream.resolution_height,
        master_fps: focus.master_live_stream.fps,
        master_saturation: focus.master_live_stream.saturation,
        master_contrast: focus.master_live_stream.contrast,
        master_brightness: focus.master_live_stream.brightness,
        master_save_mode: focus.master_live_stream.save_mode,
        master_save_interval: focus.master_live_stream.save_interval,
        // 侧摄像头
        slave_channel_no: focus.slave_live_stream.channel_no,
        slave_master_no: focus.slave_live_stream.master_no,
        slave_cloud_service: focus.slave_live_stream.cloud_service,
        slave_publish_url: $.trim(focus.slave_live_stream.publish_url),
        slave_live_rtmp_url: $.trim(focus.slave_live_stream.live_rtmp_url),
        slave_live_hls_url: $.trim(focus.slave_live_stream.live_hls_url),
        slave_live_rtsp_url: $.trim(focus.slave_live_stream.live_rtsp_url),
        slave_resolution_width: focus.slave_live_stream.resolution_width,
        slave_resolution_height: focus.slave_live_stream.resolution_height,
        slave_fps: focus.slave_live_stream.fps,
        slave_saturation: focus.slave_live_stream.saturation,
        slave_contrast: focus.slave_live_stream.contrast,
        slave_brightness: focus.slave_live_stream.brightness,
        slave_save_mode: focus.slave_live_stream.save_mode,
        slave_save_interval: focus.slave_live_stream.save_interval
      };
      let $this = this
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/live/streams'),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $this.pageChanged(this.currentPage);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    editDevice: function (row) {
      this.gameRoom = row
    },
    saveDeviceParams: function (focus) {
      var params = focus.device_wawaji
      let $this = this
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/devices/' + focus.device.iot_device_id),
        data: params
      }).then((resp) => {
        if (resp.data.errcode === 0) {
          $this.alert('保存成功', 1);
          $this.pageChanged(this.currentPage);
        } else {
          $this.alert(resp.data.errmsg, 2);
        }
      });
    },
    saveRoom: function (row) {
      let self = this;
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/game/room/' + row.game_room_id),
        data: row
      }).then(function (response) {
        let resp = response.data
        if (resp.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.errmsg, 2);
        }
      });
    },
    changeStatus: function (row, status) {
      row.status = status;
      this.saveRoom(row);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageRoomList.vue